// extracted by mini-css-extract-plugin
export var description = "styles-module--description--3d546";
export var item = "styles-module--item--1f7c2";
export var itemBg = "styles-module--itemBg--08256";
export var items = "styles-module--items--f21b3";
export var title = "styles-module--title--98656";
export var wrapper = "styles-module--wrapper--ef4dc";